import { Modal, Form, Input, message, Typography, Button, Select, Upload } from 'antd';
import { InboxOutlined, UploadOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { apiClient } from '../../api_actions';

const { TextArea } = Input;

const RestartModal = ({ open, onClose }) => {
  const [loading, setLoading] = useState(false);

    const handleSubmit = () => {
        setLoading(true);
        apiClient.post('control/restart')
    };

    useEffect(() => {
        setLoading(true)
        setLoading(false)
    }, []);

  return (
    <Modal
    title="Restart VMS?"
    open={open}
    onOk={handleSubmit}
    onCancel={onClose}
    okText="Restart VMS"
    okType="danger"
    cancelText="Cancel"
    centered
    >
    <p>Are you sure you want to restart VMS?</p>
    </Modal>
  );
};

export default RestartModal;
